module.exports = __webpack_public_path__ + "static/media/slide-8.363e7178.jpg";